var React = require('react');

function More (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 2C4 0.89543 3.10457 -1.35705e-07 2 -8.74228e-08C0.89543 -3.91405e-08 -1.35705e-07 0.89543 -8.74228e-08 2C-3.91405e-08 3.10457 0.895431 4 2 4C3.10457 4 4 3.10457 4 2Z","fill":"#333333","key":0}),React.createElement("path",{"d":"M10 2C10 0.89543 9.10457 -1.35705e-07 8 -8.74228e-08C6.89543 -3.91405e-08 6 0.89543 6 2C6 3.10457 6.89543 4 8 4C9.10457 4 10 3.10457 10 2Z","fill":"#333333","key":1}),React.createElement("path",{"d":"M16 2C16 0.89543 15.1046 -1.35705e-07 14 -8.74228e-08C12.8954 -3.91405e-08 12 0.89543 12 2C12 3.10457 12.8954 4 14 4C15.1046 4 16 3.10457 16 2Z","fill":"#333333","key":2})]);
}

More.defaultProps = {"width":"16","height":"4","viewBox":"0 0 16 4","fill":"none"};

module.exports = More;

More.default = More;
